import React, { useState, useEffect } from "react";
import Sozlesmeler from "./Sozlesmeler";
import { useLocation } from "react-router-dom";
import KvkkTablo from "./KvkkTablo";
import GizlilikCerezTablo from "./GizlilikCerezTablo";

const GizlilikCerez = () => {
  const location = useLocation();
  const [hideDate, setHideDate] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const fromFooter = searchParams.get("fromFooter");

    if (fromFooter === "true") {
      setHideDate(true);
    }
  }, [location]);

  const content = [
    {
      heading: `Yürürlük Tarihi: ${new Date()
        .toLocaleDateString("tr-TR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split(".")
        .join("/")}`,
      text: "",
      className: "tarih text-sm font-semibold text-grayy mb-0 p-2 text-center",
    },
    {
      heading: "",
      text: [
        "JUNIORS Ticaret Yazılım Limited Şirketi (Bundan sonra 'Juniors' olarak anılacaktır.) olarak gizliliğinize ve güvenliğinize önem vermekteyiz. Bu kapsamda kullanıcı deneyiminizi geliştirmek, www.juniorscenter.com internet sitemizden en iyi şekilde faydalanmanızı sağlamak ve KVKK Aydınlatma metninde yazılı amaçlarımızla sınırlı olarak çerezler kullanmaktayız. www.juniorscenter.com internet sitemizi kullandığınız sürece Gizlilik ve Çerez Politikası’nı kabul etmiş sayılırsınız. Bu kapsamda bilgisayarınıza ya da mobil cihazınıza bu metinde yer alan çerezlerin yerleştirilmesine onay verdiğiniz kabul edilir. Bu metinde çerezin ne olduğu, bilgisayarınıza yerleştirilen çerezleri ve amaçları, çerezleri nasıl silebileceğiniz konularında detaylı bilgi yer almakta olup bu metin; sizleri bu konularda bilgilendirmek amacıyla hazırlanmıştır. Bu nedenle; Gizlilik ve Çerez Politikası’nı dikkatlice okumanızı öneriyoruz.",
      ],
    },
    {
      heading: "1. Çerez (Cookie) Nedir?",
      text: [
        "Çerez, kullanıcı deneyiminizi artırmak, KVKK Aydınlatma Metni’nde yer alan veri işleme amaçlarımızı gerçekleştirmek ve güvenliğinizi sağlamak amacıyla bilgisayarınıza ya da mobil cihazınıza yerleştirdiğimiz elektronik metin dosyasıdır. Tarayıcınıza yerleştirilen çerezler bilgisayarınızdaki ya da mobil cihazınızdaki hiçbir bilgiye erişim imkânı tanımaz ve şahsi bilgilerinizin güvenliğini tehlikeye düşürmez.",
      ],
    },
    {
      heading: "2. Çerezlerin Yerleştirilmesi ve Çerez Tercihinizi Değiştirmek",
      type: "table",
      component: <GizlilikCerezTablo />,
    },
    {
      heading:
        "3. Çerez Türleri - Çeşitleri Nelerdir ve Çerezleri Neden Kullanıyoruz?",
      text: [
        "Çerezler, geçici ve zorunlu çerezler şeklinde kategorize edilmektedir. Her iki çerez türü internet sitemize eriştiğinizde tarayıcınız tarafından oluşturulur ve tarayıcınızda depolanır.",
        "<strong>Çerez Türleri;</strong>",
        "<strong>Geçici çerezler;</strong> İnternet sitemize eriştiğiniz anda tarayıcınız tarafından oluşturulur ve depolanır. İnternet sitemizden ayrıldığınızda tarayıcınız tarafından silinir.",
        "<strong>Zorunlu çerezler;</strong> İnternet sitemize eriştiğiniz anda tarayıcınız tarafından oluşturulur ve çerez tercihlerinizi değiştirmediğiniz sürece tarayıcınızda depolanmaya devam eder.",
        "Zorunlu çerezler, internet sitemizi kullanmanız için gerekli kalıcı çerezlerdir. Bu çerezler sayesinde internet sitemizdeki kayıtlı kullanıcı oturumunuz ve kullanıcı ayarlarınız hatırlanmaya devam eder. Bu çerezleri sildiğinizde ise kullanıcı bilgileriniz hatırlanmayacağından internet sitemizde yalnızca kayıtlı kullanıcılara sunulan alanları ve bölümleri kullanamazsınız. Zorunlu çerezler sadece kullanıcı bilgilerinin hatırlanması, oturumun devamını sağlamak, güvenlik ve kullanıcı bilgilerini doğrulamak amacıyla kullanılır. Zorunlu çerezler reklam, pazarlama ya da benzeri başkaca meşru bir amaç için kullanılmaz.",
        "<strong>Çerez Çeşitleri;</strong>",
        "<strong>Altyapının Geliştirilmesi İçin Gerekli Olan Çerezler:</strong>",
        "Bu çerezler, kullanıcıların juniorscenter.com internet sitesini nasıl kullandığının tespitini yaparak sitenin altyapısının geliştirilmesi, kullanıcıların karşılaştığı hataların süratle giderilmesi, internet sitesinin hızını iyileştirmek ve güvenlik açıklarının kapatılması için kullanılır. Bu çerezler sayesinde www.juniorscenter.com internet sitesinin en doğru ve hızlı şekilde çalışması sağlanır.",
        "<strong>Kişiselleştirme İçin Gerekli Olan Çerezler:</strong>",
        "Bu çerezler, kullanıcıların www.juniorscenter.com internet sitesindeki kişiselleştirilmiş tercihlerinin hatırlanmasını sağlamak amacıyla kullanılır. Bu çerezler sayesinde kullanıcılar kişisel ayarlarını ve tercihlerini kullanabileceğinden; bu çerezlerin silinmesi durumunda kullanıcıların tercihleri hatırlanmayacağından kullanıcılar kişiselleştirilmiş bir kullanıcı deneyimine sahip olamazlar.",
        "<strong>Reklam ve Pazarlama İçin Gerekli Olan Çerezler:</strong>",
        "Bu çerezler, kullanıcıların kişisel tercihlerinin ve davranışlarının hatırlanması suretiyle kullanıcılara özel reklam gösterimini sağlamak amacıyla kullanılır. Bu çerezler sayesinde kullanıcılara kişiselleştirilmiş mal ve hizmet reklamı sunulur ve bu reklamlar sınırlandırılır. Ayrıca reklam ve pazarlama etkinliklerinin başarısı derecelendirilir.",
        "<strong>Gizlilik ve Çerez Politikası’na İlişkin Değişiklikler ve Son Hükümler</strong>",
        "Gizlilik ve Çerez Politikası 6698 Sayılı Kişisel Verilerin Korunması Kanunu ile ikincil mevzuat hükümleri kapsamında düzenlenmiştir. İşbu politika, internet sitemizde yer alan KVKK Aydınlatma Metni ile Kullanıcı Sözleşmesi’ne uygun olarak hazırlanmıştır. Gizlilik ve Çerez Politikası; KVKK Aydınlatma Metni’nin eki niteliğinde olup bu metinde yazılı olmayan hususlar bakımından KVKK Aydınlatma Metni hükümleri geçerlidir. www.juniorscenter.com internet sitesi Politika’yı gerekli gördüğü zaman değiştirme hakkına sahiptir. Metnin güncel haline www.juniorscenter.com internet sitemizdeki ilgili alandan ulaşabilirsiniz. İşbu metne ilişkin talep ve sorularınız için info@juniorscenter.com  e-posta adresinden bize ulaşabilirsiniz.",
      ],
    },
  ];

  return (
    <Sozlesmeler
      title="GİZLİLİK VE ÇEREZ POLİTİKASI"
      sections={content}
      hideDate={hideDate}
    />
  );
};

export default GizlilikCerez;
